import React, { useState, useEffect } from 'react'
import { Modal as RModal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import Switch from "react-switch";
import { updatePackage } from '../../Redux/Actions/ActionPackages';

function EditPackages({ arr, open, setOpen }) {
    let dispatch = useDispatch();
    let langLocal = localStorage.getItem('absherLang');
    const [t, i18n] = useTranslation();
    const [name, setname] = useState(arr.name);
    const [name_ar, setname_ar] = useState(arr.name_ar);
    const [description, setdescription] = useState(arr.description);
    const [description_ar, setdescription_ar] = useState(arr.description_ar);
    const [price, setprice] = useState(arr.price);
    const [start_date, setstart_date] = useState(arr.start_date);
    const [end_date, setend_date] = useState(arr.end_date);
    const [is_active, setis_active] = useState(arr.is_active === 1 ? 1 : 0);
    const [loadBtn, setloabBtn] = useState(false);
    const activee = () => {
        setis_active(prevValue => (prevValue === 1 ? 0 : 1));
    };
    const FunSubmit = (e) => {
        e.preventDefault()
        console.log(name)
        console.log(name_ar)
        console.log(description)
        console.log(description_ar)
        console.log(price)
        console.log(start_date)
        console.log(end_date)
        console.log(is_active)
        dispatch(updatePackage(arr.id,name, name_ar, description, description_ar, price, start_date, end_date,is_active, setloabBtn))
    }
    return (
        <RModal
            open={open}
            onClose={() => {
                setOpen(false);
            }}
            center={false}
            classNames={{
                modal: "popAdd",
            }}
            focusTrapped={false}
        >
            <div className='popAddForm' dir={langLocal == "ar" ? "rtl" : "ltr"} >
                <h3 className={langLocal == 'ar' ? "textAlignRight" : ""}>{t('addPackage')}</h3>
                <form>
                    <div className='input_row' >
                        <div className='one_input_row'>
                            <div className='Gen_icon'>
                                <i className='fa fa-pencil' ></i>
                                <span className={langLocal == 'ar' ? "textAlignRight" : ""} >{t('name_en')}</span>
                            </div>
                            <input type="text" defaultValue={name} onChange={(e) => setname(e.target.value)} />
                        </div>
                        <div className='one_input_row' >
                            <div className='Gen_icon'>
                                <i className='fa fa-pencil' ></i>
                                <span className={langLocal == 'ar' ? "textAlignRight" : ""} >{t('name_ar')}</span>
                            </div>
                            <input type="text" defaultValue={name_ar} onChange={(e) => setname_ar(e.target.value)} />
                        </div>
                    </div>
                    <div className='input_row' >
                        <div className='one_input_row'>
                            <div className='Gen_icon'>
                                <i className='fa fa-pencil' ></i>
                                <span className={langLocal == 'ar' ? "textAlignRight" : ""} >{t('desc_en')}</span>
                            </div>
                            <textarea type="text" defaultValue={description} onChange={(e) => setdescription(e.target.value)} />
                        </div>
                        <div className='one_input_row' >
                            <div className='Gen_icon'>
                                <i className='fa fa-pencil' ></i>
                                <span className={langLocal == 'ar' ? "textAlignRight" : ""} >{t('desc_ar')}</span>
                            </div>
                            <textarea type="text" defaultValue={description_ar} onChange={(e) => setdescription_ar(e.target.value)} />
                        </div>
                    </div>
                    <div className='input_row' >
                        <div className='one_input_row'>
                            <div className='Gen_icon'>
                                <i className='fa fa-image' ></i>
                                <span className={langLocal == 'ar' ? "textAlignRight" : ""} >{t('price')}</span>
                            </div>
                            <input type="number" defaultValue={price} onChange={(e) => setprice(e.target.value)} />
                        </div>
                        <div className='one_input_row' >
                            <div className='Gen_icon'>
                                <i className='fa fa-image' ></i>
                                <span className={langLocal == 'ar' ? "textAlignRight" : ""} >{t('start_date')}</span>
                            </div>
                            <input type="date" defaultValue={start_date} onChange={(e) => setstart_date(e.target.value)} />
                        </div>
                    </div>
                    <div className='input_row' >
                        <div className='one_input_row' >
                            <div className='Gen_icon'>
                                <i className='fa fa-image' ></i>
                                <span className={langLocal == 'ar' ? "textAlignRight" : ""} >{t('end_date')}</span>
                            </div>
                            <input type="date" defaultValue={end_date} onChange={(e) => setend_date(e.target.value)} />
                        </div>
                    </div>
                    <div className='input_row' >
                        <div className='one_input_row'>
                            <Switch onColor='#36ADB0' checkedIcon={false} uncheckedIcon={false} height={20} width={40} handleDiameter={15} checked={is_active} onChange={activee} />
                        </div>
                    </div>
                </form>
                <div className='div_btn' ><button onClick={FunSubmit}  >
                    {
                        loadBtn ? "Loading ... " : <>{t('addPackage')}</>
                    }
                </button></div>
            </div>
        </RModal>
    )
}

export default EditPackages